"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavBar = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var Button_1 = __importDefault(require("react-bootstrap/Button"));
var Navbar_1 = __importDefault(require("react-bootstrap/Navbar"));
var clsx_1 = __importDefault(require("clsx"));
var NavBar = function (props) {
    var _a = props.name, name = _a === void 0 ? 'Aperza Cloud' : _a, icon = props.icon, history = props.history, path = props.path, onToggleSidebar = props.onToggleSidebar, children = props.children;
    var _b = __read(react_1.useState(false), 2), show = _b[0], setShow = _b[1];
    var title = name;
    var iconDisplay = undefined;
    if (icon) {
        iconDisplay = React.createElement("i", { className: clsx_1.default('fa', icon, 'mr-1') });
    }
    var onClick = function (e) {
        if (history && path) {
            history.push(path);
        }
        if (props.onClick) {
            props.onClick(e);
        }
    };
    var _onToggleSidebar = function () {
        if (onToggleSidebar) {
            onToggleSidebar(!show);
            setShow(!show);
        }
    };
    return (React.createElement(Navbar_1.default, { bg: "light", expand: "lg", fixed: "top", className: "justify-content-between" },
        React.createElement("div", null,
            onToggleSidebar && (React.createElement(Button_1.default, { variant: "outline-success", onClick: _onToggleSidebar, className: 'mr-2' },
                React.createElement("i", { className: clsx_1.default('fas', 'fa-bars') }))),
            React.createElement(Navbar_1.default.Brand, { href: "#" }, title)),
        React.createElement("div", { className: "d-flex" }, children)));
};
exports.NavBar = NavBar;
exports.default = NavBar;
NavBar.displayName = 'NavBar';
//# sourceMappingURL=NavBar.js.map